import { Button, EButtonColor } from '@web_opxp/components';
import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import { connect } from 'react-redux';
import { SKELETON_CLASSNAME, SKELETON_DUMMYTEXT } from '../../base/constants';
import ENV from '../../base/env';
import { SessionSelectors } from '../../session';
import { IState } from '../../store/state';
import * as Selectors from '../selectors';
import { ExerciseActions } from '../slice';
import './IntroViewLocked.scss';

export interface IIntroViewLockedProps {
  exerciseId: string | null;
  workoutId: number;
  onSkipExercise: (workoutId: number) => void;
  onUnlockPremium: () => void;
}

export const IntroViewLockedFC: React.FC<IIntroViewLockedProps> = ({
  exerciseId,
  workoutId,
  onSkipExercise,
  onUnlockPremium,
}) => {
  const { t, language } = useTranslation();

  const isLoading = exerciseId === null || !language;
  const skeletonClass = isLoading ? SKELETON_CLASSNAME : '';
  const lockedInfo = isLoading ? SKELETON_DUMMYTEXT : t('Exercise.Intro.Premium');
  const lockedInfoClasses = `exercise-info ${skeletonClass}`;
  const mainCTALabel = t('Exercise.PreWorkout.Unlock');
  const mainCTAAction = () => onUnlockPremium();
  const mainCTAClass = skeletonClass;
  const secondaryCTALabel = t('Exercise.PreWorkout.Skip');
  const secondaryCTAAction = () => onSkipExercise(workoutId);

  return (
    <>
      <div className={lockedInfoClasses}>
        <img
          className="locked-icon"
          alt="Exercise locked"
          src={`${ENV.AssetsBaseUrl}/feature/exercise-icons/icon-blocked.png`}
        />
        <p className="locked-text">{lockedInfo}</p>
      </div>
      <div className="exercise-actions">
        <Button className={mainCTAClass} label={mainCTALabel} color={EButtonColor.blue} onClick={mainCTAAction} />
        <Button
          className={skeletonClass}
          label={secondaryCTALabel}
          color={EButtonColor.white}
          onClick={secondaryCTAAction}
        />
      </div>
    </>
  );
};

export const mapStateToProps = (state: IState) => {
  const workoutId = Selectors.getWorkoutId(state);
  const exerciseId = SessionSelectors.getExerciseName(state, workoutId);
  return {
    exerciseId,
    workoutId,
  };
};

export const mapDispatchToProps = {
  onSkipExercise: ExerciseActions.skipExercise,
  onUnlockPremium: ExerciseActions.unlockPremium,
};

const IntroViewLocked = connect(mapStateToProps, mapDispatchToProps)(IntroViewLockedFC);
IntroViewLocked.displayName = 'IntroView';
export default IntroViewLocked;
